/**
 * The mount point. Reads `import.meta.env`, builds the admin client, renders. See
 * `apps/web/src/main.tsx` for why there is nothing else in here.
 */
// First, for the same reason as apps/web/src/main.tsx: this app's policy has no `'unsafe-eval'` either,
// and Zod decides about JIT at schema construction. See packages/contracts/src/interpreted-schemas.ts.
import '@apuestapr/contracts/interpreted-schemas';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { createAdminApiClient, resolveAdminApiBaseUrl } from './api/admin-api.ts';
import { App } from './App.tsx';
import { createImageUploader } from './content/upload.ts';
import './styles.css';

const container = document.querySelector('#root');
if (container === null) throw new Error('index.html must contain <div id="root">.');

const apiBaseUrl = resolveAdminApiBaseUrl(import.meta.env);
createRoot(container).render(
  <StrictMode>
    <App
      client={createAdminApiClient(import.meta.env)}
      imageUploader={createImageUploader(apiBaseUrl)}
    />
  </StrictMode>,
);
